import { Stack, Diagram, Box, Text } from "grommet";
import React from "react";

const ProcessGraph = () => {
    return (
        <>
            <Stack guidingChild={1}>
                <Diagram
                    connections={[
                        {
                            fromTarget: "1",
                            toTarget: "2",
                            thickness: "xsmall",
                            color: "brandColor",
                            anchor: "vertical",
                        },
                        {
                            fromTarget: "2",
                            toTarget: "3",
                            thickness: "xsmall",
                            color: "brandColor",
                            anchor: "vertical",
                        },
                        {
                            fromTarget: "3",
                            toTarget: "4",
                            thickness: "xsmall",
                            color: "brandColor",
                            anchor: "vertical",
                        },
                        {
                            fromTarget: "4",
                            toTarget: "5",
                            thickness: "xsmall",
                            color: "brandColor",
                            anchor: "vertical",
                        },
                        {
                            fromTarget: "5",
                            toTarget: "6",
                            thickness: "xsmall",
                            color: "brandColor",
                            anchor: "vertical",
                        },
                        {
                            fromTarget: "6",
                            toTarget: "7",
                            thickness: "xsmall",
                            color: "brandColor",
                            anchor: "vertical",
                        },
                        {
                            fromTarget: "7",
                            toTarget: "8",
                            thickness: "xsmall",
                            color: "brandColor",
                            anchor: "vertical",
                        },
                    ]}
                />
                <Box align="center" justify="center">
                    <Box width={"300px"} gap="small">
                        <Box id="1" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">Step 1: Hackathon Opens</Text>{" "}
                            <Text weight="bold" size="small" color={"brand"}>
                                11 August 2025
                            </Text>
                        </Box>
                        <Box id="2" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">Step 2: Complete the Microsoft Learn Course for Sustainability</Text>
                        </Box>
                        <Box id="3" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">Step 3: Upload your badge here</Text>
                        </Box>
                        <Box id="4" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">Step 4: Work on your Hack</Text>
                        </Box>
                        <Box id="5" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">
                                Step 5: Submit your Hack by{" "}
                                <Text weight="bold" size="small" color={"brand"}>
                                    12 September 2025
                                </Text>
                            </Text>
                        </Box>
                        <Box id="6" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">
                                Step 6: Submission Judging from{" "}
                                <Text weight="bold" size="small" color={"brand"}>
                                    15 to 19 September 2025
                                </Text>
                            </Text>
                        </Box>
                        <Box id="7" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">
                                Step 7: Top 3 Announcement{" "}
                                <Text weight="bold" size="small" color={"brand"}>
                                    22 September 2025
                                </Text>
                            </Text>
                        </Box>
                        <Box id="8" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">
                                Step 8: Winner's presentation and announcement at the Global Voices Climate Change Summit{" "}
                                <Text weight="bold" size="small" color={"brand"}>
                                    25 September 2025
                                </Text>
                            </Text>
                        </Box>
                    </Box>
                </Box>
            </Stack>
        </>
    );
};

export default ProcessGraph;
